<template>
    <div>
        <!-- <p v-if="attemptedAddress">{{ attemptedAddress }}.</p>
        <p v-else>No address has been attempted.</p> -->
        <slot></slot>
        <csrf-token-generator :form-handle="formHandle"></csrf-token-generator>
    </div>
</template>

<script>
import CsrfTokenGenerator from '@/molecules/CsrfTokenGenerator'

export default {
    name: 'WebFormErrorStyles',
    components: {
        CsrfTokenGenerator
    },
    props: {
        formHandle: {
            type: String,
            required: true
        },
    },
    watch: {},
    created() {
        this.eventCharacterMapper()

        // Change success and error messages for all forms (note: this is only for AJAX enabled forms)
        document.addEventListener('freeform-ready', (event) => {
            // Customize the error and success messages

            event.options.successBannerMessage = 'Form has been successfully Submitted'
            event.options.errorBannerMessage = 'There was an error submitting this form'
            event.options.successClassBanner = 'mb-4 text-lg'
            event.options.errorClassBanner = 'text-salmon mb-4 text-lg'
            event.options.errorClassList = 'alert-signal flex text-left text-salmon text-sm'
        })

    },
    mounted() {
        this.phoneMask()
        this.zipCodeMask()
        this.submissionMask()
    },
    methods: {
        phoneMask() {
            const formTelMask = document.querySelector('[data-form-phone-mask]')
            const inputTel = document.querySelector('[data-phone-mask]')

            if (formTelMask) {
                inputTel.addEventListener('input', (e) => {
                    const x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
                    e.target.value = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '')
                })
                formTelMask.addEventListener('submit', () => {
                    inputTel.value = inputTel.value.replace(/\-/g, '')
                })
            }
        },
        zipCodeMask() {
            let inputZipCode = document.querySelector('[data-zip-code-mask]')

            if (inputZipCode) {
                inputZipCode.addEventListener('input', (e) => {
                    e.target.value = e.target.value.replace(/\D/g, '')
                })
            }
        },

        submissionMask() {
            document.addEventListener('DOMContentLoaded', function() {
                const form = document.querySelector('[data-handle="seasonalForm2023"]');

                if (form) {
                    let pauseDateInput = document.querySelector('[pause-date-submission-mask]')
                    let returnDateInput = document.querySelector('[return-date-submission-mask]')
                    const submitButton = form.querySelector('[data-name="form_submit"]');

                    let pauseDateValid = false;
                    let returnDateValid = false;

                    // Pause Date Validation
                    if (pauseDateInput) {
                        pauseDateInput.addEventListener('blur', function (e) {
                            const inputDate = new Date(e.target.value);
                            const today = new Date();
                            const todayTimestamp = today.getTime();
                            const inputDateTimestamp = inputDate.getTime()

                            if (inputDateTimestamp < todayTimestamp) {
                                e.preventDefault()
                                pauseDateInput.classList.add("text-salmon")
                                pauseDateValid = false;
                            } else {
                                pauseDateInput.classList.remove("text-salmon")
                                pauseDateValid = true;
                            }
                        })
                    }

                    // Return Date Validation
                    if (returnDateInput) {
                        returnDateInput.addEventListener('blur', function (e) {
                            const pauseDate = new Date(pauseDateInput.value);
                            const minDate = new Date(pauseDate);
                            const inputDate = e.target.value;
                            const [month, day, year] = inputDate.split('/');
                            const parsedDate = new Date(`${year}-${month}-${day}`);
                            minDate.setDate(pauseDate.getDate() + 30);
                            const maxDate = new Date(pauseDate);
                            maxDate.setDate(pauseDate.getDate() + 280)
                            if(parsedDate < minDate || parsedDate > maxDate) {
                                e.preventDefault();
                                returnDateInput.classList.add("text-salmon")
                                returnDateValid = false;
                            } else {
                                returnDateInput.classList.remove("text-salmon")
                                returnDateValid = true;
                            }
                        })
                    }

                    //Form Submission Validation
                   form.addEventListener('submit', function (e) {
                       e.preventDefault()

                       let formIsValid = validateForm();

                       removeErrorMessage(returnDateInput)
                       removeErrorMessage(pauseDateInput)

                       if(formIsValid) {
                           form.submit()
                       } else {
                           if(!returnDateValid) {
                               returnDateInput.value = ''
                               const errorMessage = createErrorMessage("Please input a valid return date.");
                               returnDateInput.parentNode.insertBefore(errorMessage, returnDateInput);
                           }
                           if(!pauseDateValid) {
                               pauseDateInput.value = ''
                               const errorMessage = createErrorMessage("Please input a valid pause date.");
                               pauseDateInput.parentNode.insertBefore(errorMessage, pauseDateInput);
                           }
                       }
                   })

                    function createErrorMessage(message) {
                        const errorMessage = document.createElement('div');
                        errorMessage.textContent = message;
                        errorMessage.classList.add('error-message');
                        errorMessage.classList.add('text-salmon');
                        return errorMessage;
                    }

                    function removeErrorMessage(inputElement) {
                        const errorMessage = inputElement.parentNode.querySelector('.error-message');
                        if (errorMessage) {
                            errorMessage.remove();
                        }
                    }
                    function validateForm() {
                        if (returnDateValid && pauseDateValid) {
                            return true;
                        } else {
                           submitButton.addEventListener('mouseenter', function(e){
                               submitButton.disabled = false;
                           })
                            return false;
                        }
                    }
                }

                // Date input Mask
                const dateInputs = document.querySelectorAll('[data-date-mask]');

                dateInputs.forEach(input => {
                    input.addEventListener('input', function (e) {
                        let inputValue = e.target.value.replace(/\D/g, '');

                        if (inputValue.length > 2 ) {
                            inputValue = `${inputValue.slice(0,2)}/${inputValue.slice(2,4)}/${inputValue.slice(4,8)}`;
                        } else if (inputValue.length > 4) {
                            inputValue = `${inputValue.slice(0,2)}/${inputValue.slice(2,4)}/${inputValue.slice(4,8)}`;
                        }
                        e.target.value = inputValue
                    });
                });
            })
        },

        eventCharacterMapper() {
            let lengthCap = document.querySelectorAll('input[type=number][maxlength]')
            for (let i = 0; i < lengthCap.length; i++) {
                let fieldName = lengthCap[i].name.replace(/'/g, '')
                let fieldLength = document.querySelectorAll(`[name=${fieldName}]`)[i].maxLength
                this.limitCharacter(fieldLength, fieldName)
            }
        },

        limitCharacter(length, name) {
            let targetElement = document.querySelectorAll(`[name=${name}]`)[0]

            targetElement.addEventListener('keyup', () => {
                if (targetElement.value.length > length) {
                    targetElement.value = targetElement.value.substr(0, length)
                }
            })
        },
    },
}
</script>

<style>
.alert-signal::before {
    font-family: 'Font Awesome 5 Free';
    font-weight: 900;
    content: '\f06a';
    margin-top: 1px;
    margin-right: 5px;
}
</style>
